import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'gl-leave-purchase-modal',
    templateUrl: './leave-purchase-modal.component.html',
    styleUrls: ['./leave-purchase-modal.component.scss']
})
export class LeavePurchaseModalComponent {
    constructor(private modalCtrl: ModalController) {}

    async cancelLeavePurchase() {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    async leavePurchase() {
        await this.modalCtrl.dismiss(null, 'exit');
    }
}
